<template>
  <div class="blank-layout">
    <router-view />
  </div>
</template>

<script setup>
// 空白布局，用于登录页面等不需要头部导航的页面
</script>

<style scoped>
.blank-layout {
  min-height: 100vh;
  background-color: #F7F9FA;
}
</style>